<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%" :class="IpadSize || IpadProSize || MobileSize ? 'px-0' : ''">
      <v-row>
        <v-col :cols="IpadSize || MobileSize ? 8 : 6" align="start">
          <v-card-title class="px-0" style="font-weight: bold;  font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">
            <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายการสั่งซื้อสินค้า
          </v-card-title>
          <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
            <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายการสั่งซื้อสินค้า
          </v-card-title>
        </v-col>
        <v-col :cols="IpadSize || MobileSize ? 4 : 6" align="end" justify="center" class="pa-6" :class="IpadSize || MobileSize ? '' : 'pr-10'">
          <v-btn outlined color="#27AB9C" @click="openConfirmRestoreOrderModal()" :disabled="items.can_restore === 'no'">
            <v-icon left color="#27AB9C" size="20">mdi-file-refresh-outline</v-icon>คืนค่า
          </v-btn>
        </v-col>
      </v-row>
      <v-card-text :class="IpadSize || IpadProSize || MobileSize ? 'px-0' : ''">
        <v-row no-gutters class="mx-4">
          <v-col :cols="IpadSize || MobileSize ? 12 : 8" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">รหัสการสั่งซื้อ : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ items.order_number }}</span></span>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 4" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">วันที่สั่งซื้อ : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">
              <span class="text-value">
              {{ items.created_at !== undefined && items.created_at !== '' ? formatDateTH(items.created_at) : '-' }}
              </span>
            </span>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 8" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">รหัสลูกค้า : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ items.cus_code }}</span></span>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 4" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">ชื่อลูกค้า : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ items.cus_name }}</span></span>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 8" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">รหัสฝ่ายขาย : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ items.sales_code }}</span></span>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 4" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">ชื่อฝ่ายขาย : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ items.sales_name }}</span></span>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 8" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">ชื่อผู้ลบ: </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'"><span class="text-value">{{ items.deleted_name }}</span></span>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 4" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">วันที่ลบ : </span>
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">
              <span class="text-value">
                {{ items.deleted_at !== undefined && items.deleted_at !== '' ? formatDateTH(items.deleted_at) : '-' }}
              </span>
            </span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4" v-if="documentCount !== 0">
            <v-btn dark color="#27AB9C" @click="openModalDocument()">เอกสารแนบ</v-btn>
          </v-col>
          <v-col cols="12">
            <v-card outlined class="py-2">
              <!-- วันที่จัดส่ง -->
              <v-container grid-list-lg :class="IpadSize || IpadProSize || MobileSize ? 'px-0' : ''">
                <v-row no-gutters class="px-3">
                  <v-col :cols="IpadSize || IpadProSize || MobileSize ? 12 : 9">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <p :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeTitleMobile': 'fontSizeTitle'" style="font-weight: 700;">วันที่จัดส่งสินค้า</p>
                      </v-col>
                      <v-col cols="12" class="mb-4 ml-1">
                        <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">{{ items.shipping_date !== '-' ? formatDateTimeTH(items.shipping_date) : items.shipping_date }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
              <!-- ที่อยู่ในการจัดส่งสินค้า  -->
              <v-container grid-list-lg :class="IpadSize || IpadProSize || MobileSize ? 'px-0' : ''">
                <v-row no-gutters class="px-3">
                  <v-col :cols="IpadSize || IpadProSize || MobileSize ? 12 : 9">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <p :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeTitleMobile': 'fontSizeTitle'" style="font-weight: 700;">ที่อยู่ในการจัดส่งสินค้า</p>
                      </v-col>
                      <v-col cols="12" class="mb-4 ml-1">
                        <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">{{ items.cus_address ? items.cus_address : '-' }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="IpadSize || IpadProSize || MobileSize ? 12 : 3"></v-col>
                </v-row>
              </v-container>
              <!-- ที่อยู่ในการจัดส่งใบกำกับภาษี -->
              <v-container v-if="items.invoice_address !== '' && items.invoice_address !== undefined && userDetailSelling.is_gracz === 'no'" grid-list-lg :class="IpadSize || IpadProSize || MobileSize ? 'px-0' : ''">
                <v-row no-gutters class="px-3">
                  <v-col :cols="IpadSize || IpadProSize || MobileSize ? 12 : 9">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <p :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeTitleMobile': 'fontSizeTitle'" style="font-weight: 700;">ที่อยู่ในการจัดส่งใบกำกับภาษี</p>
                      </v-col>
                      <v-col cols="12" class="mb-4 ml-1">
                        <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">{{ items.invoice_address }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="IpadSize || IpadProSize || MobileSize ? 12 : 3"></v-col>
                </v-row>
              </v-container>
              <!-- accept status = success, review Desktop ipadPro-->
              <!-- product table Desktop ipadPro-->
              <v-container grid-list-xs :class="IpadSize || IpadProSize || MobileSize ? 'px-0' : ''">
                <!-- order title -->
                <v-col cols="12" class="py-0">
                  <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeTitleMobile': 'fontSizeTitle'"><b>รายการสั่งซื้อสินค้า</b></span>
                </v-col>
                <!-- table order item -->
                <v-col cols="12" class="pt-0" v-for="(order, index) in items.data_list" :key="index">
                  <v-col cols="12" class="pl-0">
                    <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">{{ order.product_list.length }} รายการสินค้า</span>
                  </v-col>
                  <v-card outlined>
                    <a-table :data-source="order.product_list" :rowKey="record => record.have_attribute === 'no' ? record.product_id : record.product_attribute_detail.product_attribute_id" :columns="IpadSize || IpadProSize || MobileSize ? headersMobile : headers" :showHeader="false" :pagination="false">
                      <template slot="productdetails" slot-scope="text, record">
                        <v-row>
                          <v-col :cols="!IpadProSize && !IpadSize && !MobileSize ? 4 : 3" class="pr-0 py-1">
                            <v-img :src="record.product_image" class="imageshow" v-if="record.product_image !== ''" contain/>
                            <v-img src="@/assets/NoImage.png" class="imageshow" contain v-else/>
                          </v-col>
                          <v-col :cols="!IpadProSize && !IpadSize && !MobileSize ? 8 : 9">
                            <p class="mb-0 DetailsProductFront">รหัสสินค้า: {{ record.sku }}<br/>{{ record.product_name }}</p>
                            <span v-if="record.product_attribute_detail.attribute_priority_1 && record.key_1_value !== 'หน่วยนับ'"  class="mb-0 DetailsProductFront">{{record.key_1_value}}: <b>{{record.product_attribute_detail.attribute_priority_1}}</b></span>
                            <span v-if="record.product_attribute_detail.attribute_priority_2" class="pl-2 mb-0 DetailsProductFront">{{record.key_2_value}}: <b>{{record.product_attribute_detail.attribute_priority_2}}</b></span>
                            <br v-if="record.product_attribute_detail.attribute_priority_1 !== '' || record.product_attribute_detail.attribute_priority_2 !== ''"/>
                            <span v-if="(IpadProSize || IpadSize || MobileSize) && shop === 'Rattana'" class="mb-0 DetailsProductFront">จำนวน {{ record.quantity }} กิโลกรัม</span>
                            <span v-if="(IpadProSize || IpadSize || MobileSize) && shop !== 'Rattana'" class="mb-0 DetailsProductFront">จำนวน {{ record.quantity }} {{ record.key_1_value === 'หน่วยนับ' ? record.product_attribute_detail.attribute_priority_1 : 'ชิ้น' }}</span>
                            <br/>
                            <span v-if="IpadProSize || IpadSize || MobileSize" class="mb-0" style="font-weight: 700; font-size: 14px; line-height: 26px; color: #000000;">
                            {{ Number(record.net_price).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
                          </span>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-if="!IpadProSize && !IpadSize && !MobileSize" slot="quantity" slot-scope="text, record">
                        <v-col cols="12">
                          <span v-if="shop === 'Rattana'">จำนวน {{ record.quantity }} กิโลกรัม</span>
                          <span v-else>จำนวน {{ record.quantity }} {{ record.key_1_value === 'หน่วยนับ' ? record.product_attribute_detail.attribute_priority_1 : 'ชิ้น' }}</span>
                        </v-col>
                      </template>
                      <template v-if="!IpadProSize && !IpadSize && !MobileSize" slot="net_price" slot-scope="text, record">
                        <span style="font-weight: 700; font-size: 16px; line-height: 26px; color: #000000;">
                          {{ Number(record.net_price).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
                        </span>
                      </template>
                    </a-table>
                    <!-- desktop card promotion -->
                    <v-card v-if="promotionList !== null && !IpadSize && !MobileSize" style="background: #FAFAFA; border-radius: 8px;" height="64" class="ma-3" elevation="0">
                      <v-card-text>
                        <v-row>
                          <v-col cols="1">
                            <v-img src="@/assets/Gracz/Order/coupon.png" width="55" height="32" contain></v-img>
                          </v-col>
                          <v-col cols="5" style="transform: translateY(6%);">
                            <span style="font-style: normal;font-weight: 400;font-size: 16px;line-height: 24px;color: #333333;">คูปองส่วนลด/โปรโมชัน</span>
                          </v-col>
                          <v-col cols="6" align="end" style="transform: translateY(6%);">
                            <span style="font-style: normal;font-weight: 500;font-size: 16px;line-height: 24px;color: #27AB9C;">{{ items.promotion_discount.promotion_name }}</span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    <!-- ipad pro, ipad, mobilecard promotion -->
                    <v-card v-if="promotionList !== null && (IpadSize || MobileSize)" style="background: #FAFAFA; border-radius: 8px;" min-height="60" class="mx-3 my-1" elevation="0">
                      <v-card-text>
                        <v-row>
                          <v-col cols="2" align="center" justify="center">
                            <v-img src="@/assets/Gracz/Order/coupon.png" width="55" height="32" contain></v-img>
                          </v-col>
                          <v-col cols="10">
                            <span style="font-style: normal;font-weight: 400;font-size: 14px;line-height: 24px;color: #333333;">คูปองส่วนลด/โปรโมชัน</span><br/>
                            <span style="font-style: normal;font-weight: 500;font-size: 14px;line-height: 24px;color: #27AB9C;">{{ items.promotion_discount.promotion_name }}</span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-card>
                </v-col>
                <!-- promotion title -->
                <v-col v-if="promotionList !== null">
                  <v-col cols="12" :class="IpadSize || IpadProSize || MobileSize ? 'pt-3 pb-0' : 'pt-4 pb-0'" class="pl-0">
                    <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeTitleMobile': 'fontSizeTitle'" style="color: #27AB9C;"><b>สินค้าโปรโมชัน</b></span>
                  </v-col>
                  <!-- table promotion item -->
                  <v-col cols="12" class="pl-0">
                    <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">{{ promotionList.product_promotion.length }} รายการสินค้า</span>
                  </v-col>
                  <v-card outlined>
                    <a-table :data-source="promotionList.product_promotion" :rowKey="record => record.have_attribute === 'no' ? record.product_id : record.product_attribute_id" :columns="IpadSize || IpadProSize || MobileSize ? headersMobile : headers" :showHeader="false" :pagination="false">
                      <template slot="productdetails" slot-scope="text, record">
                        <v-row>
                          <v-col :cols="!IpadProSize && !IpadSize && !MobileSize ? 4 : 3" class="pr-0 py-1">
                            <v-img :src="record.product_image" class="imageshow" v-if="record.product_image !== ''" contain/>
                            <v-img src="@/assets/NoImage.png" class="imageshow" contain v-else/>
                          </v-col>
                          <v-col :cols="!IpadProSize && !IpadSize && !MobileSize ? 8 : 9">
                            <p class="mb-0 DetailsProductFront">รหัสสินค้า: {{ record.sku }}<br/>{{ record.product_name }}</p>
                            <span v-if="record.attribute_priority_1 && record.attribute_1_key !== 'หน่วยนับ'" class="mb-0 DetailsProductFront">{{record.attribute_1_key}}: <b>{{record.attribute_priority_1}}</b></span>
                            <span v-if="record.attribute_priority_2" class="pl-2 mb-0 DetailsProductFront">{{record.attribute_2_key}}: <b>{{record.attribute_priority_2}}</b></span>
                            <br v-if="record.attribute_priority_1 !== '' || record.attribute_priority_2 !== ''"/>
                            <span v-if="(IpadProSize || IpadSize || MobileSize) && shop === 'Rattana'" class="mb-0 DetailsProductFront">จำนวน {{ record.quantity }} กิโลกรัม</span>
                            <span v-if="(IpadProSize || IpadSize || MobileSize) && shop !== 'Rattana'" class="mb-0 DetailsProductFront">จำนวน {{ record.quantity }} {{ record.attribute_1_key === 'หน่วยนับ' ? record.attribute_priority_1 : 'ชิ้น' }}</span>
                            <br/>
                            <span v-if="IpadProSize || IpadSize || MobileSize" class="mb-0" style="font-weight: 700; font-size: 14px; line-height: 26px; color: #000000;">0.00</span>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-if="!IpadProSize && !IpadSize && !MobileSize" slot="quantity" slot-scope="text, record">
                        <v-col cols="12">
                          <span v-if="shop === 'Rattana'">จำนวน {{ record.quantity }} กิโลกรัม</span>
                          <span v-else>จำนวน {{ record.quantity }} {{ record.attribute_1_key === 'หน่วยนับ' ? record.attribute_priority_1 : 'ชิ้น' }}</span>
                        </v-col>
                      </template>
                      <template v-if="!IpadProSize && !IpadSize && !MobileSize" slot="net_price">
                        <span style="font-weight: 700; font-size: 16px; line-height: 26px; color: #000000;">0.00</span>
                      </template>
                    </a-table>
                  </v-card>
                </v-col>
                <v-col align="start" class="pt-0">
                  <span><b>หมายเหตุ: </b>{{ items.note }}</span>
                </v-col>
              </v-container>
              <!-- price, total_price_vat, shipping Desktop ipadPro-->
              <v-container grid-list-xs v-if="!IpadProSize && !IpadSize && !MobileSize">
                <v-row>
                  <v-col cols="12" sm="9" md="10">
                    <v-row dense>
                      <v-col cols="12" class="text-right">
                        <span class="fontSizeTotalPrice">ราคา :</span>
                      </v-col>
                      <v-col cols="12" class="text-right">
                        <span class="fontSizeTotalPrice">ราคาไม่รวมภาษีมูลค่าเพิ่ม :</span>
                      </v-col>
                      <v-col cols="12" class="text-right">
                        <span class="fontSizeTotalPrice">ส่วนลด :</span>
                      </v-col>
                      <v-col cols="12" class="text-right">
                        <span class="fontSizeTotalPrice">ราคารวมหลังหักส่วนลด :</span>
                      </v-col>
                      <v-col cols="12" class="text-right">
                        <span class="fontSizeTotalPrice">ภาษีมูลค่าเพิ่ม :</span>
                      </v-col>
                      <v-col cols="12" class="text-right">
                        <span class="subheader fontSizeTotalPrice">ราคารวมทั้งหมด :</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="3" md="2">
                    <v-row dense>
                      <v-col cols="12" class="text-left">
                        <span class="fontSizeTotalPrice">{{ Number(items.total_price).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span>
                      </v-col>
                      <v-col cols="12" class="text-left">
                        <span class="fontSizeTotalPrice">{{ Number(items.total_price_no_vat).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span>
                      </v-col>
                      <v-col cols="12" class="text-left">
                        <span class="fontSizeTotalPrice">{{ Number(items.total_discount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span>
                      </v-col>
                      <v-col cols="12" class="text-left">
                        <span class="fontSizeTotalPrice">{{ Number(items.total_price_discount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span>
                      </v-col>
                      <v-col cols="12" class="text-left">
                        <span class="fontSizeTotalPrice">{{ Number(items.total_vat).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span>
                      </v-col>
                      <v-col cols="12" class="text-left">
                        <span class="fontSizeTotalPrice">{{ Number(items.net_price).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
              <v-container grid-list-xs v-else>
                <!-- สรุปรายการสั่งซื้อ ipad pro, ipad, mobile -->
                <v-row>
                  <v-col cols="12">
                    <OrderSummary :items="items"></OrderSummary>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
          <!-- status payment -->
          <v-col cols="12" class="pt-0 mt-4" v-if="shop === 'Sale Order'">
            <v-card outlined>
              <v-container grid-list-xs class="mb-2">
                <v-row no-gutters>
                  <v-col cols="12" class="mt-4">
                    <p :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeTitleMobile': 'fontSizeTitle'" style="font-weight: 700;">สถานะการชำระเงิน |
                      <v-chip class="ma-2" :color="getColor(items.transaction_status)" small :text-color="getTextColor(items.transaction_status)">
                        {{ getStatus(items.transaction_status) }}
                      </v-chip
                      >
                    </p>
                  </v-col>
                  <v-row v-if="items.transaction_status === 'Success'" no-gutters>
                    <v-col cols="12" class="mt-4">
                      <span class="mr-2" :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile': 'fontSizeDetail'">คุณได้ชำระเงินเสร็จเรียบร้อยแล้ว ขอบคุณสำหรับการใช้บริการ</span>
                    </v-col>
                    <v-col cols="12" class="mt-5">
                      <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile': 'fontSizeDetail'" style="color: #27AB9C;"><b>&#8226; หลักฐานการชำระเงิน</b></span>
                    </v-col>
                    <v-col cols="1" :class="IpadSize || IpadProSize ? 'mt-8' : 'mt-9'">
                      <v-row style="width: 20px;" :class="MobileSize ? 'ml-0' : IpadSize ? 'ml-2' : 'ml-4'">
                        <v-img src="@/assets/ImageINET-Marketplace/PoSeller/paid_success.png" :height="MobileSize ? '240px' : IpadSize || IpadProSize ? '212px': '100%'"></v-img>
                      </v-row>
                    </v-col>
                    <v-col cols="11" class="mt-5">
                      <v-row no-gutters>
                        <v-col :cols="MobileSize || IpadSize ? 5 : 4">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'">รหัสการสั่งซื้อ : </span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 7 : 8">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'" style="font-weight: bold; ">{{ items.order_number }}</span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 5 : 4" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'">ผลลัพธ์การทำรายการ : </span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 7 : 8">
                          <v-chip class="ma-2" :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'" color="#E6F5F3" small text-color="#27AB9C">สำเร็จ</v-chip>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 5 : 4" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'">จำนวนเงิน :  </span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 7 : 8" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'" style="font-weight: bold; ">{{ Number(items.receipt[0].TxnAmount).toLocaleString(undefined, { minimumFractionDigits: 2 }) || '-'}} บาท</span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 5 : 4" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'">วันและเวลาที่ทำรายการ : </span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 7 : 8" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'" style="font-weight: bold; ">{{new Date(items.receipt[0].created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })}}</span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 5 : 4" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'">Ref : </span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 7 : 8" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'" style="font-weight: bold; ">{{ items.receipt[0].orderIDRef }}</span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 5 : 4" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'">ธนาคาร : </span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 7 : 8" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'" style="font-weight: bold; ">{{ bankName }}</span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 5 : 4" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'">รูปแบบการชำระเงิน : </span>
                        </v-col>
                        <v-col :cols="MobileSize || IpadSize ? 7 : 8" class="mt-2">
                          <span :class="IpadSize || IpadProSize ? 'fontSizeDetailMobile': MobileSize ? 'fontSizeXs' : 'fontSizeDetail'" style="font-weight: bold; ">{{ items.receipt[0].payType }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="items.transaction_status === 'Cancel' && dataRole.role === 'purchaser'" no-gutters>
                    <v-col cols="12">
                      <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile': 'fontSizeDetail'">คำสั่งซื้อสินค้าของคุณถูกยกเลิก</span>
                    </v-col>
                    <v-col cols="12" class="mt-5" v-if="item.transaction_status !== 'Cancel'">
                      <span style="color: #27AB9C;" :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile': 'fontSizeDetail'"><b>&#8226; รายละเอียดใบสั่งซื้อที่ถูกยกเลิก</b></span>
                    </v-col>
                    <v-col cols="12" align="left" v-if="item.transaction_status !== 'Cancel'">
                      <v-timeline dense>
                        <v-timeline-item v-for="(item, index) in items.approver_list" :key="index" fill-dot class="white--text mb-12" color="#27AB9C" small>
                          <template v-slot:icon>
                            <span>{{ index + 1 }}</span>
                          </template>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <span style="color: #27AB9C;"><b>ผู้อนุมัติ</b></span>
                            </v-col>
                            <v-col cols="12">
                              <span style="color: black;">สถานะ : </span>
                              <v-chip v-if="item.status === 'cancel'" class="ma-2" color="#F7D9D9" small text-color="#D1392B">ยกเลิกสินค้า</v-chip>
                              <v-chip v-else class="ma-2" color="#E6F5F3" small text-color="#27AB9C">อนุมัติ</v-chip>
                            </v-col>
                            <v-col cols="12">
                              <span style="color: black;" :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile': 'fontSizeDetail'">ผู้อนุมัติ : {{ item.approver_name }}({{ item.email }})</span>
                            </v-col>
                            <v-col v-if="item.time_approve === '-'" cols="12" class="mt-3">
                              <span style="color: black;" :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile': 'fontSizeDetail'">วันที่อนุมัติ : {{ item.time_approve }}</span>
                            </v-col>
                            <v-col v-else cols="12" class="mt-3">
                              <span style="color: black;" :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile': 'fontSizeDetail'">วันที่อนุมัติ : {{ new Date(item.time_approve).toLocaleDateString("th-TH", { year: "numeric", month: "long", day: "numeric" }) }}</span>
                            </v-col>
                          </v-row>
                        </v-timeline-item>
                      </v-timeline>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="items.transaction_status === 'Cancel' && dataRole.role === 'ext_buyer'" no-gutters>
                    <v-col cols="12" class="mt-4">
                      <span class="mr-2" :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile': 'fontSizeDetail'">
                        คุณได้ทำการยกเลิกคำสั่งซื้อ หากต้องการซื้อสินค้าอีกครั้ง
                        สามารถเข้าไปเลือกซื้อสินค้ากับเราได้เลย
                      </span>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="items.transaction_status === 'Fail'" no-gutters>
                    <v-col cols="12" class="mt-4">
                      <span class="mr-2" :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile': 'fontSizeDetail'">
                        คุณชำระเงินไม่สำเร็จ
                        กรุณาตรวจสอบการชำระเงินของคุณอีกครั้ง
                      </span>
                    </v-col>
                  </v-row>
                  <v-row v-else no-gutters>
                    <v-col cols="12" class="mt-4">
                    </v-col>
                  </v-row>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- dialog comfirm delete order -->
    <v-dialog  v-model="dialogConfirmRestoreOrder" width="400" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar color="#BDE7D9" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">คืนค่ารายการสั่งซื้อสินค้าที่ถูกลบ</font></span>
          <v-btn icon dark @click="dialogConfirmRestoreOrder = false">
            <v-icon color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br/><br/>
        <v-card-text >
          <span>คุณต้องการคืนค่ารายการสั่งซื้อสินค้าที่ถูกลบนี้ ใช่หรือไม่ ?</span>
        </v-card-text>
        <v-card-actions >
          <v-container >
            <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="closeConfirmRestoreOrder()">ยกเลิก</v-btn>
            <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="restoreOrder()">ตกลง</v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DocumentData ref="DocumentData"/>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
import moment from 'moment'
export default {
  components: {
    OrderSummary: () => import('@/components/Gracz/Sales/Cart/Card/OrderSummary.vue'),
    DocumentData: () => import('@/components/Gracz/Modal/DocumentData')
  },
  data () {
    return {
      items: {},
      orderNumber: '',
      userDetailSelling: '',
      dialogConfirmRestoreOrder: false,
      promotionList: null,
      bankName: '',
      shop: '',
      documentCount: 0
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push({ path: `/Order/DeletedOrderDetailMobile?orderNumber=${this.orderNumber}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/Order/DeletedOrderDetail?orderNumber=${this.orderNumber}` }).catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    },
    headers () {
      const headers = [
        {
          title: 'รายละเอียดสินค้า',
          dataIndex: 'productdetails',
          key: 'productdetails',
          scopedSlots: { customRender: 'productdetails' },
          width: '50%'
        },
        {
          title: 'จำนวน',
          dataIndex: 'quantity',
          key: 'quantity',
          scopedSlots: { customRender: 'quantity' },
          align: 'center',
          width: '20%'
        },
        {
          title: 'ราคารวม',
          dataIndex: 'net_price',
          scopedSlots: { customRender: 'net_price' },
          key: 'net_price',
          align: 'center',
          width: '20%'
        }
      ]
      return headers
    },
    headersMobile () {
      const headers = [
        {
          title: 'รายละเอียดสินค้า',
          dataIndex: 'productdetails',
          key: 'productdetails',
          scopedSlots: { customRender: 'productdetails' },
          width: '100%'
        }
      ]
      return headers
    }
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      this.orderNumber = this.$route.query.orderNumber
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      this.checkShop()
      if (this.shop === 'Sale Order') {
        this.getDataSaleOrder()
      } else {
        this.getData()
      }
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/DeletedOrderListMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/DeletedOrderList' }).catch(() => {})
      }
    },
    checkShop () {
      if (this.userDetailSelling.is_gracz === 'yes') {
        this.shop = 'Gracz'
      } else {
        if (this.userDetailSelling.is_rattana === 'yes') {
          this.shop = 'Rattana'
        } else {
          this.shop = 'Sale Order'
        }
      }
    },
    async getData () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        order_number: this.orderNumber
      }
      await this.$store.dispatch('actionsGraczDetailOrder', data)
      var response = await this.$store.state.ModuleGraczOrder.stateGraczDetailOrder
      if (response.message === 'Get detail order success') {
        this.$store.commit('closeLoader')
        this.items = response.data
        this.documentCount = this.items.document.length
        this.promotionList = response.data.promotion_discount
        if (this.items.receipt.length !== 0) {
          if (this.items.receipt[0].bankNo === 'SCB') {
            this.bankName = 'ธนาคารไทยพาณิชย์ (SCB)'
          } else if (this.items.receipt[0].bankNo === 'BBL') {
            this.bankName = 'ธนาคารกรุงเทพ (BBL)'
          } else if (this.items.receipt[0].bankNo === 'KTB') {
            this.bankName = 'ธนาคารกรุงไทย (KTB)'
          } else if (this.items.receipt[0].bankNo === 'BAY') {
            this.bankName = 'ธนาคารกรุงศรีอยุธยา (BAY)'
          } else if (this.items.receipt[0].bankNo === 'KTC') {
            this.bankName = 'บริษัทบัตรกรุงไทย (KTC)'
          } else {
            this.bankName = 'ธนาคารอื่นๆ'
          }
        } else {
          this.bankName = ''
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async getDataSaleOrder () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        order_number: this.orderNumber
      }
      await this.$store.dispatch('actionsGraczDetailOrderSaleOrder', data)
      var response = await this.$store.state.ModuleGraczOrder.stateGraczDetailOrderSaleOrder
      if (response.message === 'Get detail order success') {
        this.$store.commit('closeLoader')
        this.items = response.data
        this.documentCount = this.items.document.length
        this.promotionList = response.data.promotion_discount
        if (this.items.receipt.length !== 0) {
          if (this.items.receipt[0].bankNo === 'SCB') {
            this.bankName = 'ธนาคารไทยพาณิชย์ (SCB)'
          } else if (this.items.receipt[0].bankNo === 'BBL') {
            this.bankName = 'ธนาคารกรุงเทพ (BBL)'
          } else if (this.items.receipt[0].bankNo === 'KTB') {
            this.bankName = 'ธนาคารกรุงไทย (KTB)'
          } else if (this.items.receipt[0].bankNo === 'BAY') {
            this.bankName = 'ธนาคารกรุงศรีอยุธยา (BAY)'
          } else if (this.items.receipt[0].bankNo === 'KTC') {
            this.bankName = 'บริษัทบัตรกรุงไทย (KTC)'
          } else {
            this.bankName = 'ธนาคารอื่นๆ'
          }
        } else {
          this.bankName = ''
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    openConfirmRestoreOrderModal () {
      this.dialogConfirmRestoreOrder = true
    },
    closeConfirmRestoreOrder () {
      this.dialogConfirmRestoreOrder = false
    },
    async restoreOrder () {
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        order_number: this.orderNumber
      }
      await this.$store.dispatch('actionsGraczRecoverOrder', data)
      var response = await this.$store.state.ModuleGraczOrder.stateGraczRecoverOrder
      if (response.status === 200) {
        this.closeConfirmRestoreOrder()
        this.$swal.fire({ icon: 'success', text: response.message, showConfirmButton: false, timer: 2000 })
        this.$EventBus.$emit('getDeleteOrderList')
        if (this.MobileSize) {
          this.$router.push('/Order/DeletedOrderListMobile').catch(() => {})
        } else {
          this.$router.push('/Order/DeletedOrderList').catch(() => {})
        }
      } else {
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    formatDateTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var dateTH = moment(date).locale('TH').format('D MMMM ' + year)
      return dateTH
    },
    formatDateTimeTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var time
      var dateTH
      if (date !== undefined) {
        time = date.split(' ')[1].split(':')
        dateTH = moment(date).locale('TH').format('D MMMM ' + year + ' เวลา ' + time[0] + ':' + time[1] + ' น.')
      }
      return dateTH
    },
    openModalDocument () {
      console.log('AAAA', this.items)
      this.$refs.DocumentData.open(this.items)
    },
    getColor (item) {
      if (item === 'Pending') return '#FCF0DA'
      else if (item === 'Not Paid') return '#FCF0DA'
      else if (item === 'Success') return '#F0F9EE'
      else if (item === 'Approve') return '#F0F9EE'
      else if (item === 'Fail') return '#F7D9D9'
      else if (item === 'Credit Term') return '#E5EFFF'
      else if (item === 'Cash') return '#F0F9EE'
      else return '#F7D9D9'
    },
    getTextColor (item) {
      if (item === 'Pending') return '#E9A016'
      else if (item === 'Not Paid') return '#E9A016'
      else if (item === 'Success') return '#1AB759'
      else if (item === 'Approve') return '#1AB759'
      else if (item === 'Fail') return '#D1392B'
      else if (item === 'Credit Term') return '#1B5DD6'
      else if (item === 'Cash') return '#1AB759'
      else return '#D1392B'
    },
    getStatus (item) {
      if (item === 'Pending') return 'รออนุมัติ'
      else if (item === 'Not Paid') return 'ยังไม่ชำระเงิน'
      else if (item === 'Success') return 'ชำระเงินสำเร็จ'
      else if (item === 'Approve') return 'วางบิล'
      else if (item === 'Fail') return 'ชำระเงินไม่สำเร็จ'
      else if (item === 'Credit Term') return 'ชำระเงินแบบเครดิตเทอม'
      else if (item === 'Cash') return 'ชำระเงินสด'
      else return 'ยกเลิกคำสั่งซื้อ'
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'User not found in shop.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Order not found.') {
        return ['ไม่พบรายการสั่งซื้อ', 'warning']
      } else if (msg === 'Deleter not found in shop.') {
        return ['ไม่พบผู้ลบรายการสั่งซื้อในร้าน', 'warning']
      } else if (msg === 'user not found.') {
        return ['ไม่พบข้อมูลผู้ลบรายการสั่งซื้อ', 'warning']
      } else {
        return [msg, 'error']
      }
    }
  }
}
</script>
<style lang="css" scoped>
.imageshow {
  width: 80px;
  height: 80px;
}
.imageshowMobile {
  width: 60px;
  height: 60px;
  /* cursor: pointer; */
}
.bgShippingUPS {
  background-color: #F3F5F7;
}
.fontActive {
  color: #27AB9C;
}
.fontInactive {
  color: #A6A6A6;
}
.fontSizeStepOrder {
  font-size: 11px;
}
.fontSizeTotalPrice {
  font-size: 18px;
}
.fontSizeTotalPriceMobile {
  font-size: 16px;
}
.fontSizeAddressDetail {
  font-size: 16px;
}
.buttonFontSize {
  font-size: 14px;
  font-weight: normal;
}
.captionSku {
  font-size: 12px;
}
.fontSizeTitle {
  font-weight: 700;
  font-size: 21px;
  color: #333333;
}
.fontSizeTitleMobile {
  font-weight: 700;
  font-size: 18px;
  color: #333333;
}
.text-value {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.fontSizeDetail {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.fontSizeDetailMobile {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.fontSizeTotalPrice {
  font-size: 16px;
}
.fontSizeTotalPriceMobile {
  font-size: 14px;
}
.DetailsProductFrontMobile {
  font-size: 12px;
}
.ant-card-bordered {
  border: 0px solid #e8e8e8;
}
</style>
